<template>
    <el-dialog title="" :visible.sync="visible" style="padding: 0;" center width="400px" append-to-body 		:before-close="handleColumnControl"
    >
        <el-tabs stretch v-model="activeName">
            <el-tab-pane name="yhmm" :label="$t('密码登录')">
                <el-row style="text-align: center">{{ requestOption.gsmc }}</el-row>
                <el-form :model="companyLogin" ref="company" label-width="100px" style="margin-top: 10px"
                    v-show="!isCompanyLogin">
                    <el-form-item :label="$t('手机号')" prop="mobile">
                        <el-input ref="mobile" class="input" :placeholder="$t('请输入手机号')"
                            v-model.input.lazy.trim="companyLogin.mobile" clearable>
                        </el-input>
                    </el-form-item>
                    <el-form-item :label="$t('密码')" prop="yhmm">
                        <el-row>
                            <el-input ref="yhmm" class="input" :placeholder="$t('请输入密码')" show-password
                                v-model.input.lazy.trim="companyLogin.yhmm"></el-input>
                        </el-row>
                    </el-form-item>
                </el-form>
                <el-row type="flex" justify="center">
                    <el-col :span="24" class="buttons">
                        <el-button type="primary" style="width: 100%" :loading="loginLoading" @click="login()">{{
                            $t("用户登录")
                        }}</el-button>
                    </el-col>
                </el-row>
            </el-tab-pane>
        </el-tabs>
    </el-dialog>
</template>

<script>
export default {
    name: "LoginDialog",
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            activeName: "yhmm", //选中标签类别值
            requestOption: {},
            companyLogin: {
                mobile: "",
                yhmm: "",
            },
            isCompanyLogin: false,
            loginLoading: false,
        }
    },
    methods: {
        handleColumnControl() {
			this.$emit("update:visible", false);
		},
        async login() {
            const login = await this.$API.HKAPI({
                type: "login_kh",
                phe: this.companyLogin.mobile,
                dwmm: this.companyLogin.yhmm,
                // dwxh:this.companyLogin.mobile
            });
            if (login.data.Status == '1') {
                localStorage.setItem("dwinfo", JSON.stringify(login.data));
                this.$message({
                    type: "success",
                    message: this.$t("登陆成功"),
                    center: true,
                });
                this.handleColumnControl();
                location.reload();
            } else {
                this.$message({
                    type: "error",
                    message: this.$t("登陆失败"),
                    center: true,
                });
            }

        },
    }

}
</script>

<style scope lang="less">
.el-dialog--center .el-dialog__body{
    padding-top: 0 !important;
}
</style>